__turbopack_context__.v({
  "enter": "styles-module-scss-module__iEguKW__enter",
  "exit": "styles-module-scss-module__iEguKW__exit",
  "fade-in": "styles-module-scss-module__iEguKW__fade-in",
  "fade-out": "styles-module-scss-module__iEguKW__fade-out",
  "fade-out-80": "styles-module-scss-module__iEguKW__fade-out-80",
  "icon": "styles-module-scss-module__iEguKW__icon",
  "label": "styles-module-scss-module__iEguKW__label",
  "required": "styles-module-scss-module__iEguKW__required",
  "size13": "styles-module-scss-module__iEguKW__size13",
  "size14": "styles-module-scss-module__iEguKW__size14",
  "size16": "styles-module-scss-module__iEguKW__size16",
  "size18": "styles-module-scss-module__iEguKW__size18",
  "slide-in-from-bottom": "styles-module-scss-module__iEguKW__slide-in-from-bottom",
  "slide-in-from-left": "styles-module-scss-module__iEguKW__slide-in-from-left",
  "slide-in-from-right": "styles-module-scss-module__iEguKW__slide-in-from-right",
  "slide-in-from-top": "styles-module-scss-module__iEguKW__slide-in-from-top",
  "slide-out-to-bottom": "styles-module-scss-module__iEguKW__slide-out-to-bottom",
  "slide-out-to-left": "styles-module-scss-module__iEguKW__slide-out-to-left",
  "slide-out-to-right": "styles-module-scss-module__iEguKW__slide-out-to-right",
  "slide-out-to-top": "styles-module-scss-module__iEguKW__slide-out-to-top",
  "title": "styles-module-scss-module__iEguKW__title",
  "zoom-in": "styles-module-scss-module__iEguKW__zoom-in",
  "zoom-out": "styles-module-scss-module__iEguKW__zoom-out",
});
